import TextLibraryLandingPage from '../pages/landing/TextLibraryLandingPage'
// import VoiceLibraryItems from '../pages/subPages/VoiceLibrary'
import VoiceLibrarySelection from '../pages/subPages/VoiceLibrarySelection'
import AudioLibraryItems from '../pages/subPages/AudioLibrary'
// Import original Voice Lab components (commented out but kept for reference)
// import VoiceLabCharacterList from '../pages/subPages/VoiceLabCharacterList'
// import VoiceLabMyRecordings from '../pages/subPages/VoiceLabMyRecordings'

// Import Book Creator Worksheet Wrapper
// import BookCreatorWorksheetWrapper from './BookCreatorWorksheetWrapper'
// Import Enhanced Book Worksheet Page Wrapper
import { BookWorksheetPageWrapperEnh } from '../bookWorksheet'

// Import integrated Voice Lab components
import VoiceLabCharacterList from '../pages/subPages/VoiceLabCharacterList.integrated'
import VoiceLabMyRecordings from '../pages/subPages/VoiceLabMyRecordings.integrated'
import VoiceLabIntegrationDemo from '../pages/subPages/VoiceLabIntegrationDemo'
import VoiceActorsList from '../pages/subPages/VoiceActorsList'
// import VoiceActorWorksheet from '../pages/subPages/VoiceActorWorksheet'
// import VoiceActorWorksheetPageWrapper from '../voiceActorWorksheet/components/VoiceActorWorksheetPageWrapper'
import { VoiceActorWorksheetPageWrapperEnh } from '../voiceActorWorksheet'
import VoiceActorAssignments from '../pages/subPages/VoiceActorAssignments'
import MyAssignments from '../pages/subPages/MyAssignments'
import MyPortfolio from '../pages/subPages/MyPortfolio'
import MySampleVoices from '../pages/subPages/MySampleVoices'
import VoiceSampleWorksheet from '../pages/subPages/voiceActor/VoiceSampleWorksheet'
// Phase 4d Step 3 — Rendering Studio R1. Lazy-import-friendly default export
// so the sidebar can route to the eye-test grid inside the Dashboard shell.
import RenderingStudio from '../pages/subPages/bookCreator/RenderingStudio'
// ARCHIVED: import WorkInProgress from '../pages/subPages/WorkInProgress'
import MessagingTest from '../pages/subPages/MessagingTest'
import StoryImporter from '../pages/subPages/StoryEditor'
import AIFileEditor from '../pages/subPages/AIFileEditor'
import ArticleEditor from '../pages/subPages/ArticleEditor'
import AIQueryEditor from '../pages/subPages/AIQueryEditor'
import SystemManagement from '../pages/admin/SystemManagement'
// import BookDetails from '../pages/BookDetails'
import Checkout from "../pages/Checkout"
import { useSelector } from 'react-redux'
import { selectActiveRole } from '../slices/userRoleSlice'
import { hasFeatureAccess } from '../utils/roleUtils'

export default function DashBoardPages(subPageId = 'TEXT-LIBRARY') {
  console.log('GOTO PAGE ', subPageId)
  // Get the active role to check permissions
  const activeRole = useSelector(selectActiveRole) || 'admin';

  const renderSubPage = (subPageId) => {
    // Check if the user has access to this feature based on their role
    // If not, return a message or redirect to a default page

    const featureMap = {
      'BOOK-DETAILS': 'bookDetails',
      'TEXT-LIBRARY': 'textLibrary',
      'VOICE-LIBRARY': 'voiceLibrary',
      'AUDIO-LIBRARY': 'audioLibrary',
      'VOICE-LAB': 'voiceLab',
      'VOICE-LAB-MY-RECORDINGS': 'voiceLabMyRecordings',
      'VOICE-LAB-DEMO': 'voiceLabDemo',
      'VOICE-ACTORS': 'voiceActors',
      // 'VOICE-ACTOR-WORKSHEET': 'voiceActorWorksheet',
      'VOICE-ACTOR-WORKSHEET-ENH': 'voiceActorWorksheetEnh',
      'VOICE-ACTOR-ASSIGNMENTS': 'voiceActorAssignments',
      'MY-ASSIGNMENTS': 'myAssignments',
      'MY-PORTFOLIO': 'myPortfolio',
      'MY-SAMPLE-VOICES': 'mySampleVoices',
      'VOICE-SAMPLE-WORKSHEET': 'VoiceSampleWorksheet',
      // 'WORK-IN-PROGRESS': 'workInProgress', // ARCHIVED
      // 'VOICE-RECORDER-LAB': 'voiceRecorderLab',
      'STORY-IMPORTER': 'storyImporter',
      'AI-FILE-LAB': 'aiFileLab',
      'ADMIN-ARTICLE-EDITOR': 'adminArticleEditor',
      'ADMIN-AI-QUERY-EDITOR': 'adminAiQueryEditor',
      'USER-MANAGEMENT': 'userManagement',
      'BOOK-CREATOR-WORKSHEET': 'bookCreatorWorksheet',
      'MESSAGING-TEST': 'messagingTest',
      'RENDERING-STUDIO': 'renderingStudio'
    };

    // Get the feature name for the subPageId
    const featureName = featureMap[subPageId];

    // If admin, allow access to everything
    if (activeRole !== 'admin' && featureName) {
      // Check if the user has access to this feature
      const hasAccess = hasFeatureAccess(activeRole, featureName);
      if (!hasAccess) {
        // Return a default page or access denied message
        return (
          <div className="access-denied" style={{ padding: '20px', textAlign: 'center' }}>
            <h2>Access Denied</h2>
            <p>You don't have permission to access this feature with your current role: {activeRole}</p>
          </div>
        );
      }
    }

    // Render the appropriate component based on subPageId
    switch (subPageId) {
      // case 'BOOK-DETAILS': return <BookDetails />
      case 'BOOK-DETAILS': return <BookWorksheetPageWrapperEnh />
      // case 'TEXT-LIBRARY': return <TextLibraryItems />
      case 'TEXT-LIBRARY': return <TextLibraryLandingPage />
      // case 'VOICE-LIBRARY': return <VoiceLibraryItems />
      case 'VOICE-LIBRARY': return <VoiceLibrarySelection />
      case 'AUDIO-LIBRARY': return <AudioLibraryItems />
      case 'VOICE-LAB': return <VoiceLabCharacterList />
      case 'VOICE-LAB-MY-RECORDINGS': return <VoiceLabMyRecordings />
      case 'VOICE-LAB-DEMO': return <VoiceLabIntegrationDemo />
      case 'VOICE-ACTORS': return <VoiceActorsList />
      // case 'VOICE-ACTOR-WORKSHEET': return <VoiceActorWorksheet />
      case 'VOICE-ACTOR-WORKSHEET-ENH': return <VoiceActorWorksheetPageWrapperEnh />
      case 'VOICE-ACTOR-ASSIGNMENTS': return <VoiceActorAssignments />
      case 'MY-ASSIGNMENTS': return <MyAssignments />
      case 'MY-PORTFOLIO': return <MyPortfolio />
      case 'MY-SAMPLE-VOICES': return <MySampleVoices />
      case 'VOICE-SAMPLE-WORKSHEET': return <VoiceSampleWorksheet />
      // case 'WORK-IN-PROGRESS': return <WorkInProgress /> // ARCHIVED
      case 'STORY-IMPORTER': return <StoryImporter />
      case 'AI-FILE-LAB': return <AIFileEditor />
      case 'ADMIN-ARTICLE-EDITOR': return <ArticleEditor />
      case 'ADMIN-AI-QUERY-EDITOR': return <AIQueryEditor />
      case 'USER-MANAGEMENT': return <SystemManagement />
      case 'MESSAGING-TEST': return <MessagingTest />
      case 'CHECKOUT': return <Checkout />
      case 'BOOK-CREATOR-WORKSHEET': return <BookWorksheetPageWrapperEnh />
      case 'RENDERING-STUDIO': return <RenderingStudio />
      default: break;
      // throw new Error();
    }
  }

  return renderSubPage(subPageId)
}
